
define('ldsh!modules/accounts/status/products/mdirector/balance/transfer/resume/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="transfer-resume-content">\n  <div class="mb12">\n    <p class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.TEXT"></p>\n  </div>\n\n  <div id="resume" class="panel panel-info">\n    <div class="panel-body">\n        <div style="padding-bottom: 5px;">\n            <strong><span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.ORIGEN"></span>:</strong>\n            <span style="padding-left: 10px;" id="statusGroupName">' +
__e(balance.get("name")) +
'</span>\n        </div>\n        <div style="padding-bottom: 5px;">\n            <strong><span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.DESTINATION"></span>:</strong>\n            <span style="padding-left: 10px;" id="subaccounts">' +
__e(model.get("empName")) +
'</span>\n        </div>\n        <strong><span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.TRANSFER"></span></strong>\n        ';

            var tagLabel = "LBL_EMAILS";
            var leftLabel = "LBL_LEFT_EMAILS";
            var amountLeft = balance.get("balance").numOfEmailsLeftInPack- model.get("value");
            if (model.get("field") === "sms_country") {
                amountLeft = model.get("countrySms") - model.get("value");
                tagLabel = "LBL_SMS";
                leftLabel = "LBL_LEFT_SMS";
            }
        ;
__p += '\n        <span style="padding-left: 10px;" id="statusGroupName">' +
__e(model.get("value")) +
'</span>\n        <span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.' +
__e(tagLabel) +
'"></span>\n        <div style="padding-top: 5px;">\n            <strong><span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.' +
__e(leftLabel) +
'"></span>:</strong>\n            <span style="padding-left: 10px;font-family: arial;">' +
__e(formatNumber(amountLeft)) +
'</span>\n            <span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.' +
__e(tagLabel) +
'"></span>\n            ';
 if (model.get("field") === "sms_country") { ;
__p += '\n            <span> (' +
__e(model.get("countryName")) +
')</span>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n  </div>\n</div>\n<div id="transfer-resume-spinner" class="text-center" style="display: none;">\n    <i class="ri-loader-4-fill fa-spin" style="font-size: 120px;"></i>\n</div>\n\n<div class="flex align-center justify-end">\n  <button id="confirm" class="btn--primary">\n      <span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESUME.CONFIRM"></span>\n  </button>\n</div>\n';

}
return __p
};});

